export const LOCAL_STORAGE = {
  theme: 'theme',
  newWellForm: 'new-well-form',
  unfinishedWellIds: 'unfinishedWellIds',
};
